const topMain = (() => {
  if (document.querySelector("body#pageTop") !== null) {



    let secMain = document.querySelector('#jsSecMain');
    let tigrWraps = secMain.querySelectorAll('.js-tigr-wrap');



    let imgWrap = secMain.querySelector('.js-img-wrap');
    let imgBoxs = imgWrap.querySelectorAll('.js-img-box');

    let capWrap = secMain.querySelector('.js-cap-wrap');

    {
      let cap = capWrap.querySelector('.js-cap');

      let to1 = gsap.to(imgBoxs[1], {
        opacity: 1,
        ease: "none",
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: tigrWraps[2],
          start: "0% 100%",
          end: "0% 0%",
          scrub: 0,
          // onEnter: () => console.log("onEnter"),
          onLeave: () => cap.classList.add('is-act'),
          onEnterBack: () => cap.classList.remove('is-act'),
          // onLeaveBack: () => console.log("onLeaveBack"),
          // markers: true,
        },
      })
      let to2 = gsap.to(imgBoxs[1], {
        scale: 1,
        ease: "none",
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: tigrWraps[4],
          start: "0% 100%",
          end: "0% 0%",
          // onEnter: () => console.log("onEnter"),
          // onLeave: () => cap.classList.add('is-act'),
          // onEnterBack: () => cap.classList.remove('is-act'),
          // onLeaveBack: () => console.log("onLeaveBack"),
          scrub: 0,
          // markers: true,
        },
      })

      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          to1.scrollTrigger.refresh()
          to2.scrollTrigger.refresh()
        });
      });
      observer.observe(target);
    }



    let coverWrap = secMain.querySelector('.js-cover-wrap');
    let coverBoxs = coverWrap.querySelectorAll('.js-cover-box');
    {
      let to0 = gsap.to(coverBoxs[0], {
        opacity: 0,
        ease: "none",
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: tigrWraps[0],
          start: "100% 100%",
          end: "100% 0%",
          scrub: 0,
          // markers: true,
        },
      })
      let to1 = gsap.to(coverBoxs[1], {
        opacity: .9,
        ease: "none",
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: tigrWraps[1],
          start: "0% 100%",
          end: "0% 0%",
          scrub: 0,
          // markers: true,
        },
      })
      let to2 = gsap.to(coverBoxs[1], {
        opacity: 0,
        ease: "none",
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: tigrWraps[3],
          start: "0% 100%",
          end: "0% 0%",
          scrub: 0,
          // markers: true,
        },
      })
      let to3 = gsap.to(coverBoxs[2], {
        opacity: 1,
        ease: "none",
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: '#jsSecIntro',
          start: "0% 100%",
          end: "0% 0%",
          scrub: 0,
          // markers: true,
        },
      })
      let to4 = gsap.to(coverBoxs[3], {
        opacity: 1,
        ease: "none",
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: '#jsSecMerit',
          start: "0% 100%",
          end: "0% 0%",
          scrub: 0,
          // markers: true,
        },
      })

      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          to1.scrollTrigger.refresh()
          to2.scrollTrigger.refresh()
          to3.scrollTrigger.refresh()
          to4.scrollTrigger.refresh()
        });
      });
      observer.observe(target);
    }



    let copyWrap = secMain.querySelector('.js-copy-wrap');
    {
      let copyBox = copyWrap.querySelector('.js-copy-box');
      setTimeout(() => {
        copyBox.classList.add('is-act')
      }, 1000);
    }
    {
      let tl = gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: copyWrap,
          endTrigger: secMain,
          start: "0% 0%",
          end: "100% 100%",
          pin: true,
          pinSpacing: false,
          // markers: true,
        },
      })

      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          tl.scrollTrigger.refresh()
        });
      });
      observer.observe(target);
    }







  }
})()
export default topMain;